import { Dimensions } from 'react-native';

export const ScreenWidth = Dimensions.get('window').width;
